import "./TicketListItem.scss";
import { useDispatch, useSelector } from "react-redux";
import TicketDetailedView from '../../TicketDetailedView/TicketDetailedView';
import { setSelectedTicket, updateTicket } from "../../../../../slices/TicketSlice";

function TicketListItem({ ticket }) {
  const dispatch = useDispatch();
  const selectedTicket = useSelector((state) => state.tickets.selectedTicket);
  const isOpen = selectedTicket?.id === ticket?.id;

  function handleClick() {
    if (!ticket) return;
    if (isOpen) {
      dispatch(updateTicket());
    } else {
      dispatch(setSelectedTicket(ticket));
    }
  }

  const normalizedStatus = (ticket?.status || "")
    .toString()
    .toLowerCase()
    .replaceAll("_", " ")
    .trim();

  const statusClass = {
    open: "status-open",
    unassigned: "status-unassigned",
    "in progress": "status-in-progress",
    blocked: "status-blocked",
    resolved: "status-resolved",
    closed: "status-closed",
  }[normalizedStatus] || "status-unknown";

  const displayStatus = normalizedStatus
    ? normalizedStatus.replace(/\b\w/g, (letter) => letter.toUpperCase())
    : "Unknown";

  return (
    <div className="ticketlistitem-container">
      <button
        className="ticketlistitem"
        onClick={handleClick}
        type="button"
        data-testid="ticket-list-item-button"
      >
        <div className="ticket-main-content">
          <div className="title-label">Ticket Title:</div>
          <p className="ticket-title" data-testid="ticket-title">
            {ticket?.title ?? "Untitled Ticket"}
          </p>
          <div className="id-container">
            <span className="id-label">Ticket ID:</span>
            <p className="ticket-id" data-testid="ticket-id">
              {ticket?.id ?? "N/A"}
            </p>
          </div>
        </div>

        <div className="status-container">
          <span className="status-label">Status:</span>
          <p className={`ticketstatus ${statusClass}`} data-testid="ticket-status">
            {displayStatus}
          </p>
        </div>
      </button>

      {isOpen && (
        <div className="ticketdetailedview-container">
          <TicketDetailedView
            onClose={() => dispatch(setSelectedTicket(null))}
            data-testid="ticket-detailed-view"
          />
        </div>
      )}
    </div>
  );
}

export default TicketListItem;
